import { useLayoutContext } from "layout/layout-provider";
import { useEffect } from "react";

const useShowLayout = () => {
  const { setFooterHidden, setHeaderHidden } = useLayoutContext();

  useEffect(() => {
    setFooterHidden(false);
    setHeaderHidden(false);
  }, [setFooterHidden, setHeaderHidden]);
};

export default useShowLayout;
